import { LandingFooter } from "../landing/footer/LandingFooter";
import { Image } from "./Image";
import { Logo } from "./Logo";

export const Footer = ({ className }: { className?: string }) => {
  return (
    <LandingFooter
      className={className}
      description="Display your Shopify store metrics on the big screen"
      withBackground
      withBackgroundGlow={false}
      variant="primary"
      backgroundGlowVariant="primary"
      withBackgroundGradient={false}
      logoComponent={<Logo />}
      descriptionFooter={
        <span className="opacity-70 inline-flex items-center gap-1 text-sm">
          <span>Built by</span>
          <a href="https://itsoneiota.com" className="inline-flex items-center">
            <Image
              src="/landing/static/images/oneiota-logo.png"
              alt="One Iota"
              width={500}
              height={94}
              className="w-[65px] mt-[-3px]"
            />
          </a>
        </span>
      }
    >
      <div className="flex flex-col gap-3 text-sm">
        <div className="font-semibold">Compare</div>
        <a
          href="/alternative-to-geckoboard"
          className="opacity-70 transition-opacity hover:opacity-100"
        >
          Alternative to Geckoboard
        </a>
      </div>
    </LandingFooter>
  );
};

export default Footer;
